<template>
  <div style="background-color: #fff" v-title :data-title="$route.query.seo_title">
    <!-- 头部 -->
    <el-row>
      <header-elem></header-elem>
      <!-- 轮播图 -->
      <rotation-elem></rotation-elem>
    </el-row>

    <!-- 内容主体 -->
    <el-row style="width: 1200px;margin: 0 auto;margin-bottom: 20px;">
      <el-col :span="24">
        <el-col :span="7">
          <!-- 左侧导航 -->
          <leftNav-elem></leftNav-elem>
        </el-col>
        <el-col :span="17">
          <el-col :span="24" class="now_position">
            <!-- 当前位置 -->
            <nowposition-elem></nowposition-elem>
          </el-col>
          <!-- 文章列表 -->

          <el-col :span="24" style="border: 1px solid #dbdbdb;padding: 15px 20px;margin-bottom: 20px;">
            <div class="title">{{details.title}}</div>

            <div class="sub_title">
              {{details.updatetime}}
              <span class="time">来源：{{details.copyfrom}}</span>
              <span class="time" v-if="details.nickname">作者：{{details.nickname}}</span>
              <span class="time">点击量：{{details.click}}</span>
            </div>
            <div v-html="details.content"></div>
          </el-col>
        </el-col>
      </el-col>
    </el-row>
    <!-- 底部 -->
    <el-row style="margin-top: 20px;">
      <el-col :span="24">
        <footer-elem></footer-elem>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import headerElem from "@/components/com/header";
import rotationElem from "@/components/com/rotation";
import footerElem from "@/components/com/footer";
import leftNavElem from "@/components/com/leftNav";
import nowpositionElem from "@/components/com/nowPosition";

var that;

export default {
  components: {
    "header-elem": headerElem,
    "rotation-elem": rotationElem,
    "footer-elem": footerElem,
    "leftNav-elem": leftNavElem,
    "nowposition-elem": nowpositionElem
  },
  data() {
    return {
      id: "",
      title: "",
      details: {}
    };
  },
  beforeCreate() { },
  created() {
    that = this;
    that.detail(that.$route.query.id);
    // console.log(that.$route.query);
    if (isMobile()) {
      location.href = "http://www.hsfyzx.cn/mobile/index.html#/?id=" +that.$route.query.id +"&fId=" +that.$route.query.fId +"&sId=" +that.$route.query.sId +"&seo_title=" +that.$route.query.seo_title;
      // location.href ="http://172.16.2.167:8081/#/?id=" +that.$route.query.id +"&fId=" + that.$route.query.fId +"&sId=" +that.$route.query.sId +"&seo_title=" +that.$route.query.seo_title;
    } else {
      // that.detail(that.$route.query.id);
    }
  },
  mounted() {

  },
  beforeRouteEnter(to, from, next) {
    //在当前路由改变，但是该组件被复用时调用
    window.scrollTo(0, 0);
    next();
  },
  beforeRouteUpdate(to, from, next) {
    //在当前路由改变，但是该组件被复用时调用
    window.scrollTo(0, 0);
    next();
  },
  updated() {
    that.$nextTick(function () {
      var position = Number(sessionStorage.getItem("searchScrollHei"));
      $(document).scrollTop(position);
    });
  },
  methods: {
    detail(id) {
      $.ajax({
        type: "post",
        url: url + "/archivedetail?id=" + id,
        data: {},
        success: function (data) {
          if (data.code == "0") {
            console.log(data);
            that.details = data.data;
            that.title = data.data.seo_title;
          } else if (data.code == "1") {
            that.details = {};
          }
        },
        error(data) {
          // alert('123');
        }
      });
    }
  }
};
</script>
<style scoped>
.now_position {
  text-align: right;
}
.title {
  font-size: 25px;
  font-weight: bold;
  width: 100%;
  text-align: center;
  margin: 20px 0;
}
.sub_title {
  background: #f1f1f1;
  border: 1px solid #d5d5d5;
  text-align: center;
  line-height: 30px;
  margin: 20px 0;
}
.time {
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/article.vue